// extracted by mini-css-extract-plugin
module.exports = {"abtn_box":"Abutton_abtn_box__2Olbp","btn_diamond":"Abutton_btn_diamond__3OBfJ","btn_bagcolor":"Abutton_btn_bagcolor__2R-XD"};